var Component = require("!./../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../vue-loader/lib/selector?type=script&index=0!./sample-2.vue"),
  /* template */
  require("!!./../../vue-loader/lib/template-compiler?id=data-v-01a5d762!./../../vue-loader/lib/selector?type=template&index=0!./sample-2.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader!./~/vue-markdown-loader/_cache/sample-2.vue
// module id = 218
// module chunks = 0